var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('vue-p5',_vm._g({},{ setup: _vm.setup, mouseclicked: _vm.mouseclicked }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }